import { actionCreator } from "src/store/dataService/actions/utils/actionCreator";
import { API } from "src/store/dataService/types";
import { CashPayment } from "Types/api/CashPayment";
import { DealerOffer } from "Types/api/DealerOffer";
import { LeasePayment } from "Types/api/LeasePayment";
import { LoanPayment } from "Types/api/LoanPayment";

interface VehiclePaymentsPatch {
    cash?: Partial<CashPayment>;
    loan?: Partial<LoanPayment>;
    lease?: Partial<LeasePayment>;
    selected?: "cash" | "loan" | "lease";
    dealer?: Partial<DealerOffer>;
}

/**
 * Patch request
 */
export const patchPaymentsRequest = actionCreator(
    "payments/patch/request",
    (
        uuid: string,
        vin: string,
        payments: VehiclePaymentsPatch,
        eventName?: string,
        eventFieldType?: "slider" | "input"
    ) => ({ uuid, vin, payments }),
    (
        uuid: string,
        vin: string,
        payments: VehiclePaymentsPatch,
        eventName?: string,
        eventFieldType?: "slider" | "input"
    ) => ({
        route: API.Payments,
        analytics: { eventName, eventFieldType },
    })
);

/**
 * Patch success
 */
export const patchPaymentsSuccess = actionCreator(
    "payments/patch/success",
    (vin: string, payments: VehiclePaymentsPatch) => ({
        vin,
        payments,
    })
);

/**
 * Patch failure
 */
export const patchPaymentsFailure = actionCreator("payments/patch/failure", (vin: string) => ({ vin }));
